module.exports = __webpack_public_path__ + "static/media/roboto-700italic.81f57861.woff";